import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Lightning, X } from "@phosphor-icons/react";
import api from "@/lib/api";
import { slotLabel, useBusyAlerts } from "@/lib/useBusyAlerts";

export default function BusyHourNotice({ user }) {
  const isMb = user?.role === "media_buyer";
  const { data, reload } = useBusyAlerts(isMb, 5 * 60 * 1000);
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 60000);
    return () => { clearInterval(t); };
  }, []);
  const alert = (data?.active || []).find((a) => new Date(a.ends_at) > new Date());
  if (!isMb || !alert) return null;
  const mins = Math.round((new Date(alert.starts_at) - Date.now()) / 60000);
  const when = mins > 0 ? `starts in ${mins} min` : "is happening now";
  const dismiss = async () => {
    try {
      await api.post(`/media-buyer/busy-alerts/${encodeURIComponent(alert.id)}/dismiss`);
      reload();
    } catch {
      toast.error("Couldn't dismiss the alert");
    }
  };
  return (
    <div className="bg-emerald-700 text-white px-4 py-2 flex items-start sm:items-center gap-3 text-sm" data-testid="busy-hour-notice">
      <Lightning size={16} weight="fill" className="shrink-0 mt-0.5 sm:mt-0" />
      <span className="flex-1 min-w-0" data-testid="busy-hour-notice-text">
        <b>Busy hour ahead:</b> {slotLabel(alert, false)} Eastern {when}. Last 4 weeks: {alert.sold} sold from {alert.generated} leads.
      </span>
      <Link to="/results" className="underline text-[11px] uppercase tracking-widest shrink-0" data-testid="busy-hour-notice-open">Open results</Link>
      <button type="button" onClick={dismiss} aria-label="Dismiss" className="p-1 shrink-0 hover:bg-emerald-800 transition-colors" data-testid="busy-hour-notice-dismiss">
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
